// The roles an owner can give a team member (StoreUser::ROLES on the backend),
// shared by the invite panel and the add-by-phone form.
export const ROLES = [
  { value: 'sales_admin', label: 'Team member', hint: 'Day-to-day access to stock, clients and deals.' },
  { value: 'store_admin', label: 'Store admin', hint: 'Everything above, plus settings.' },
  { value: 'owner', label: 'Owner', hint: 'Full control, including the team.' },
];
